import React from "react"
import { Flex, FlexProps, IconButton, IconButtonProps } from "@chakra-ui/core"
import * as R from "ramda"

type StarsInputProps = FlexProps & {
  name?: string
  defaultValue?: number
}

const StarButton = (props: IconButtonProps) => (
  <IconButton icon="star" variant="ghost" {...props} />
)

export default React.forwardRef(function StarsInput(
  { name, defaultValue = 1, ...props }: StarsInputProps,
  ref: React.RefObject<HTMLInputElement>
) {
  const [value, setValue] = React.useState(defaultValue)

  return (
    <Flex {...props}>
      <input type="hidden" name={name} value={value} ref={ref} />
      {R.range(0, 5).map((index) => (
        <StarButton
          key={index}
          aria-label={`${index + 1} stars`}
          onClick={() => setValue(index)}
          color={index <= value ? "primary" : "noon"}
          _hover={{
            color: "dawn",
          }}
        />
      ))}
    </Flex>
  )
})
